import initEvents from '../../../actions/events/initEvents';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { store } from '../../../store/store';
import { useAppSelector } from '../../../store/hooks';
import { useEffect, useRef } from 'react';

export default function useEvents() {
  const { channelsData } = useAppSelector(channelsSelector);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  // Fetch events after all required data is obtained

  useEffect(() => {
    channelsData?.length && initEvents(true);
  }, [channelsData]);

  // Keep refreshing events on a self-rescheduling loop. Reading
  // `lastModifiedDate`/`updateRate` from the store (instead of depending on
  // them as hook/effect values) matters because `updateRate` can legitimately
  // get set to the same number on two consecutive fetches (e.g. two
  // "NEXT_HOURS" fetches that both land outside the accelerated window each
  // reset it to the same flat 3h rate) — an unchanged effect dependency would
  // never re-run, permanently stopping the refresh loop after that point.

  useEffect(() => {
    if (!channelsData?.length) return undefined;

    const scheduleNext = () => {
      const { lastModifiedDate, updateRate } = store.getState().events;
      const timeoutValue = lastModifiedDate
        ? lastModifiedDate - Date.now()
        : updateRate;

      if (!timeoutValue) return;

      timeoutRef.current = setTimeout(() => {
        initEvents();
        scheduleNext();
      }, timeoutValue);
    };

    scheduleNext();

    return () => clearTimeout(timeoutRef.current);
  }, [channelsData]);
}
